import './maturity-compliances.scss'

import { Card, Table } from 'antd'
import React from 'react'
import { Column, Row } from 'react-display-flex'
import useSWR from 'swr'

import { fetchDetailByDomain } from '../../../../api'
import { renderPrincipal } from '../../../../components/tables/table-column-renderers'
import { IsCompliant } from '../IsCompliant'
import { maturityCompliancesTableColumns } from './maturity-compliances-table-columns'

interface MaturityLimit {
  amountAvailable: string
  amountInvested: number
  investmentSharePct: number
  isCompliant: boolean
  label: string
  maxLimitPct: number
  minLimitPct: number
  offLimit: number
  tradesCount: number
}

interface MaturityCompliance {
  isCompliant: boolean
  amountInvested: number
  tradesCount: number
  maturityLimits: MaturityLimit[]
}

export const MaturityCompliances = ({ tenant }) => {
  const { data: maturityCompliances } = useSWR<MaturityCompliance>(
    tenant ? ['/compliances/maturities', tenant] : null,
    fetchDetailByDomain,
  )

  return (
    <Card title="Maturity Compliances" className="maturity-compliances" loading={!maturityCompliances}>
      <Row justifyContentSpaceBetween>
        <Column>
          <dt>Trades Count</dt>
          <dd>{maturityCompliances?.tradesCount ? maturityCompliances?.tradesCount : 0}</dd>
        </Column>
        <Column>
          <dt>Amount Invested</dt>
          <dd>{renderPrincipal(maturityCompliances?.amountInvested ? maturityCompliances?.amountInvested : 0)}</dd>
        </Column>
        <Column>
          <dt>Is Compliant</dt>
          <dd>
            <IsCompliant isCompliant={maturityCompliances?.isCompliant} />
          </dd>
        </Column>
      </Row>

      <Table
        dataSource={maturityCompliances?.maturityLimits}
        loading={!maturityCompliances}
        columns={maturityCompliancesTableColumns}
        pagination={false}
        rowKey="label"
        size="small"
      />
    </Card>
  )
}
